export default __webpack_public_path__ + "static/media/logo6.336ea50c.jpg";